import styled from 'styled-components'

import FocalImage from 'ui/blocks/FocalImage'

export const BundleItem = styled.div`
  display: flex;
  align-items: center;

  gap: 12px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  ${FocalImage} {
    width: 32px;
    height: 32px;
  }
`

export const Toggle = styled.div`
  display: flex;
  align-items: center;

  cursor: pointer;

  margin-bottom: 8px;

  gap: 4px;

  svg {
    width: 16px;
    height: 16px;

    fill: var(--line-toggle-color);
    color: var(--line-toggle-color);
  }
`

export const ToggleText = styled.span`
  font-family: var(--font-body);
  font-size: var(--line-toggle-font-size);

  font-weight: 600;

  color: var(--line-toggle-color);
`

export const Quantity = styled.span`
  font-family: var(--font-body);
  font-size: var(--line-bundle-item-quantity-font-size);

  color: var(--line-bundle-item-quantity-color);
`

export const Name = styled.span`
  font-family: var(--font-body);
  font-size: var(--line-bundle-item-name-font-size);

  color: var(--line-bundle-item-name-color);
`
